export const procedureMap: GenericObject = {
	ativo: "active",
	rubrica: "rubric",
	idademinima: "minAge",
	idademaxima: "maxAge",
	exigeidade: "requiresAge",
	valorunitario: "unitValue",
	maximopaciente: "maxPatient",
	sexopermitido: "allowedGender",
	tipocomplexidade: "complexityType",
	codigofinanciamento: "fundingCode",
	codigoprocedimento: "code",
	nomeprocedimento: "name",
};
